var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "source-funnels-chart",
      class: { fullscreen: _vm.fullScreen },
    },
    [
      _vm.fullScreen
        ? _c(
            "div",
            { staticClass: "title" },
            [
              _c("ChartDoddleIcon"),
              _vm._v(" "),
              _c("h2", [
                _vm._v(_vm._s(_vm.$t("adminReportsPage.titleCustomerFunnels"))),
              ]),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "toolbar" }, [
        _c("div", { staticClass: "left" }, [
          _c(
            "div",
            { staticClass: "buttons" },
            [
              _c(
                "IconButton",
                {
                  directives: [
                    {
                      name: "tippy",
                      rawName: "v-tippy",
                      value: { content: _vm.$t("report.chartView") },
                      expression: "{ content: $t('report.chartView') }",
                    },
                  ],
                  attrs: {
                    classNames: _vm.tableMode ? "" : "selected",
                    onClick: function () {
                      return (_vm.tableMode = false)
                    },
                  },
                },
                [_c("md-icon", [_vm._v("insights")])],
                1
              ),
              _vm._v(" "),
              _c(
                "IconButton",
                {
                  directives: [
                    {
                      name: "tippy",
                      rawName: "v-tippy",
                      value: { content: _vm.$t("report.tableView") },
                      expression: "{ content: $t('report.tableView') }",
                    },
                  ],
                  attrs: {
                    classNames: _vm.tableMode ? "selected" : "",
                    onClick: function () {
                      return (_vm.tableMode = true)
                    },
                  },
                },
                [_c("md-icon", [_vm._v("table_view")])],
                1
              ),
              _vm._v(" "),
              _c(
                "IconButton",
                {
                  directives: [
                    {
                      name: "tippy",
                      rawName: "v-tippy",
                      value: { content: _vm.$t("report.download") },
                      expression: "{ content: $t('report.download') }",
                    },
                  ],
                  attrs: { onClick: _vm.exportToExcel },
                },
                [_c("md-icon", [_vm._v("download")])],
                1
              ),
              _vm._v(" "),
              _c(
                "IconButton",
                {
                  directives: [
                    {
                      name: "tippy",
                      rawName: "v-tippy",
                      value: { content: _vm.$t("report.fullScreen") },
                      expression: "{ content: $t('report.fullScreen') }",
                    },
                  ],
                  attrs: { onClick: _vm.switchToFullScreenMode },
                },
                [
                  !_vm.fullScreen
                    ? _c("md-icon", [_vm._v("fullscreen")])
                    : _c("md-icon", [_vm._v("fullscreen_exit")]),
                ],
                1
              ),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "toolbar filter-toolbar" }, [
        _c(
          "div",
          { staticClass: "left" },
          [
            _c("CommonFilterTool", {
              attrs: {
                "keep-state-on-query-params": false,
                "filter-meta": _vm.filterMetas,
                "label-formatter": _vm.filterLabelFormatter,
              },
              on: { addFilter: _vm.addFilter },
              model: {
                value: _vm.breakdownFilter,
                callback: function ($$v) {
                  _vm.breakdownFilter = $$v
                },
                expression: "breakdownFilter",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "source-buttons" }, [
        _c(
          "div",
          { staticClass: "buttons" },
          _vm._l(_vm.getAllUtmSourceList(), function (source) {
            return _c(
              "SupsisButton",
              {
                key: source,
                attrs: {
                  classNames: _vm.selectedUtmSource ? "" : "selected",
                  small: "",
                  ghost: source !== _vm.selectedUtmSource,
                  primary: source === _vm.selectedUtmSource,
                },
                on: {
                  click: function () {
                    return (_vm.selectedUtmSource = source)
                  },
                },
              },
              [_vm._v("\n                " + _vm._s(source) + "\n            ")]
            )
          }),
          1
        ),
      ]),
      _vm._v(" "),
      !_vm.tableMode
        ? _c("FunnelChart", {
            attrs: {
              title: "Müşteri Takip Kırılımları",
              legends: _vm.legends,
              colors: _vm.colors,
              series: _vm.getSeries(),
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.tableMode
        ? _c("TableView", {
            attrs: { cols: _vm.getCols(), rows: _vm.getRows() },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "stats" },
        [
          _c("StatCard", {
            attrs: {
              title: "General Win Rate",
              value: _vm.stats.ViewWinPercent,
              unit: "%",
            },
          }),
          _vm._v(" "),
          _c("StatCard", {
            attrs: {
              title: "Demo Form Win Rate",
              value: _vm.stats.DFWinPercent,
              unit: "%",
            },
          }),
          _vm._v(" "),
          _c("StatCard", {
            attrs: {
              title: "Demo Form Visit Percent",
              value: _vm.stats.ViewerDFViewerPercent,
              unit: "%",
            },
          }),
          _vm._v(" "),
          _c("StatCard", {
            attrs: {
              title: "Demo Form Submit Percent",
              value: _vm.stats.DFSubmitterPercent,
              unit: "%",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }